/**
 * СТруктура организации. Модуль для работы с API.
 * @module organizationalUnits
 */

/**
 * Получает структуру организации.
 * @returns {Promise<Object>} - Данные структуры.
 * @throws {Error} - Ошибка при получении данных.
 */
export const getTree = async () => {
  try {
    const response = await fetch("/api/organizationalunitstree", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data.result;
  } catch (err) {
    throw err;
  }
};
